import { Component, EventEmitter, Input, Output, ViewChild, OnChanges } from '@angular/core';
import { UploadedFile } from '../../models/uploaded-file.model';

@Component({
standalone: false,
  selector: 'app-document-icon-slider',
  templateUrl: './document-icon-slider.component.html',
  styleUrls: ['./document-icon-slider.component.scss'],
})
export class DocumentIconSliderComponent implements OnChanges {
  @Input() public files: UploadedFile[] = [];
  @Output() public showPreview = new EventEmitter();

  // @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;

  public indexTab: number[];
  public activeIndex = 0;
  // public readonly config: SwiperConfigInterface = {
  //   direction: 'horizontal',
  //   slidesPerView: 2,
  //   centeredSlides: true,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true,
  //     hideOnClick: false,
  //   },
  // };

  ngOnChanges(): void {
    if (this.files.length > 1) {
      // this.directiveRef.update();
    }
  }
}
